import { CallAnsweredByType } from "@/types/call.types";

export const CALL_ANSWER_STATUS_FILTERS = ["answered", "voicemail", "not_answered"] as const;

export type CallAnswerStatusFilter = (typeof CALL_ANSWER_STATUS_FILTERS)[number];

export const ANSWER_STATUS_TO_ANSWERED_BY: Record<CallAnswerStatusFilter, CallAnsweredByType[]> = {
    answered: [CallAnsweredByType.HUMAN],
    voicemail: [CallAnsweredByType.MACHINE_START],
    not_answered: [CallAnsweredByType.UNKNOWN, CallAnsweredByType.FAX],
};
